<template>
  <section>
    <div class="personal-center-form__section prepayment_cont">
      <h1 class="loan_detail_h1">提前还款</h1>

      <div class="loan_detail_first">
        <ul class="text-center">
          <li>
            <em>未还金额</em>
            <strong><i>¥ {{detail.balancedSum | addThousandSign(2)}}</i></strong>
            <span>申请时间  {{detail.applyDate}}</span>
          </li>
          <li>
            <em>贷款金额</em>
            <strong>¥{{detail.loanAmount | addThousandSign(2)}}</strong>
          </li>
          <li>
            <el-button class="repay_btn" :disabled="isDisabled" @click="toRepay" :loading="isRepay">{{toRepayText}}</el-button>
          </li>
        </ul>
      </div>

      <!-- <div class="repayment_money">
       <el-form :model="repayForm" :rules="rules" ref="repayForm" label-width="80px" class="repayment-form__form">
         <el-form-item label="还款金额" prop="repaymentMoney">
           <el-input v-model="repayForm.repaymentMoney" :value="123" placeholder="请输入还款金额" @change="chenckRepayment()"></el-input>
         </el-form-item>
       </el-form>
      </div> -->

      <div class="repayment-tips">从{{detail.bankAccountInfo}}自动扣款</div>

      <section class="info-card">
        <div class="info-card-item">
          <span class="info-card-item-ch ml10">还款本金</span>
          <!-- <span class="info-card-item-num">¥ {{detail.balancedPrincipal | addThousandSign(2)}}</span> -->
          <el-input class="info-card-item-num max_110" v-model="detail.balancedPrincipal" placeholder="还款金额" @blur="ischeckRepayment"
          @focus="isRepay = true">
            <template slot="prepend">¥</template>
          </el-input>
          <i class="vertical-line"></i>
        </div>
        <div class="info-card-item">
          <span class="info-card-item-ch">还款利息</span>
          <span class="info-card-item-num">¥ {{detail.balancedInterest | addThousandSign(2)}}</span>
          <i class="vertical-line"></i>
        </div>
        <div class="info-card-item">
          <span class="info-card-item-ch">还款咨询费</span>
          <span class="info-card-item-num">¥ {{detail.balancedFee | addThousandSign(2)}}</span>
          <i class="vertical-line"></i>
        </div>
        <div class="info-card-item">
          <span class="info-card-item-ch">还款违约金</span>
          <span class="info-card-item-num">¥ {{detail.shouldPenalty | addThousandSign(2)}}</span>
        </div>
      </section>

      <div class="repayTip" v-html="repayTip" v-if="isrepayTip"></div>

    </div>
  </section>
</template>
<script>
  import _ from 'lodash'
  import * as types from '../../vuex/types'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  export default {
    data () {
      return {
        frontApplyId: 2,
        isSmall: true,
        index: 1,
        isRepay: false,
        repayTip: '',
        isrepayTip: false,
        showManagerDialog: false,
        itemApplyId: this.$route.params.itemApplyId,
        isDisabled: false,
        balancedSums: '',
        toRepayText: '我要还款'
        // repayForm: {
        //   repaymentMoney: ''
        // },
        // rules: {
        //   repaymentMoney: [{
        //     required: true,
        //     trigger: 'blur',
        //     validator: (rules, value, callback) => {
        //       if (value.trim() === '') {
        //         callback(new Error('请输入还款金额'))
        //       } else if (_.isNaN(Number(value))) {
        //         callback(new Error('还款金额必须为数字'))
        //       } else if (value > this.detail.balancedPrincipal) {
        //         callback(new Error(`还款金额不可以大于${this.detail.balancedPrincipal}元`))
        //       } else if (value < 1) {
        //         callback(new Error(`还款金额不可以小于1元`))
        //       } else {
        //         callback()
        //       }
        //     }
        //   }]
        // }
      }
    },
    computed: {
      ...mapGetters({
        detail: types.GET_PREPAYMENT_DETAIL,
        userInfo: types.GET_USER,
        frontItemApplyState: types.FRONT_ITEM_STATE_FRONT
      })
    },
    methods: {
      ...mapActions({
        getPrepaymentData: types.GET_PREPAYMENT_DATA,
        advanceConfirm: types.ADVANCE_CONFIRM,
        getPartPrepaymentMoney: types.GET_PART_PREPAYMENT_MONEY
      }),
      ...mapMutations({
        setPrepaymentDetail: types.SET_PREPAYMENT_DETAIL,
        setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
        setFailModal: types.SET_FAIL_MESSAGE_STATE
      }),
      // chenckRepayment () {
      //   this.$refs.repayForm.validate((valid) => {
      //     if (valid) {
      //     } else {
      //       return false
      //     }
      //   })
      // },
      ischeckRepayment () {
        const balancedPrincipal = this.detail.balancedPrincipal
        if (_.trim(balancedPrincipal) === '') {
          this.setFailModal({
            show: true,
            content: '请输入提前还款金额'
          })
        } else if (_.isNaN(Number(balancedPrincipal))) {
          this.setFailModal({
            show: true,
            content: '提前还款金额只能为数字'
          })
        } else if (Number(balancedPrincipal) <= 0) {
          this.setFailModal({
            show: true,
            content: '提前还款金额必需大于0'
          })
        } else if (Number(balancedPrincipal) > this.detail.loanAmount) {
          this.setFailModal({
            show: true,
            content: '超过允许的提前还款金额'
          })
        } else {
          this.checkRepayment()
        }
      },
      checkRepayment () {
        this.getPartPrepaymentMoney({
          token: this.userInfo.token,
          balancedPrincipal: this.detail.balancedPrincipal,
          itemApplyId: this.itemApplyId,
          pay: 0
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            this.detail.balancedInterest = res.data.data.balancedInterest
            this.detail.balancedFee = res.data.data.balancedFee
            this.detail.shouldPenalty = res.data.data.shouldPenalty
            this.balancedSums = res.data.data.balancedSum
            this.isRepay = false
          } else {
            // 如果接口返回数据异常
            this.setFailModal({
              show: true,
              content: res.data.result
            })
            this.$router.go(-1)
          }
        }).catch(() => {
          setTimeout(() => {
            this.isRepay = false
          }, 1000)
        })
      },
      toRepay () {
        const _this = this
        if (!_this.isDisabled) {
          _this.$confirm(`提前还款，金额为：${this.balancedSums ? this.balancedSums : this.detail.balancedSum}元`, ' ', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            _this.isRepay = true
            _this.toRepayText = '还款中...'
            _this.advanceConfirm({
              token: this.userInfo.token,
              itemApplyId: this.itemApplyId,
              balancedPrincipal: this.detail.balancedPrincipal,
              balancedInterest: this.detail.balancedInterest,
              balancedFee: this.detail.balancedFee,
              shouldPenalty: this.detail.shouldPenalty,
              pay: 1
            }).then((res) => {
              if (Number(res.data.code) === 0) {
                _this.isDisabled = true
                _this.toRepayText = '已经还款'
                _this.setSuccessModal({
                  show: true,
                  content: res.data.result
                })
                _this.$router.go(-1)
              } else {
                _this.isDisabled = false
                _this.isRepay = false
                _this.toRepayText = '我要还款'
                _this.setFailModal({
                  show: true,
                  content: res.data.result
                })
              }
            })
          }).catch(() => {

          })
        }
      }
      // toRepay () {
      //   const _this = this
      //   if (!_this.isDisabled) {
      //     _this.$confirm(`提前还款，金额为：${this.detail.balancedSum}元`, ' ', {
      //       cancelButtonText: '取消',
      //       confirmButtonText: '确定',
      //       type: 'warning'
      //     }).then(() => {
      //       _this.advanceConfirm({
      //         token: this.userInfo.token,
      //         itemApplyId: this.itemApplyId
      //       }).then((res) => {
      //         if (Number(res.data.code) === 0) {
      //           _this.isDisabled = true
      //           _this.toRepayText = '已经还款'
      //           _this.setBalanceSum(0)
      //           _this.setSuccessModal({
      //             show: true,
      //             content: res.data.result
      //           })
      //         } else {
      //           _this.isDisabled = false
      //           _this.toRepayText = '我要还款'
      //           _this.setFailModal({
      //             show: true,
      //             content: res.data.result
      //           })
      //         }
      //       })
      //     }).catch(() => {

      //     })
      //   }
      // }
    },
    mounted () {
      this.getPrepaymentData({
        token: this.userInfo.token,
        itemApplyId: this.itemApplyId,
        frontItemApplyState: this.frontItemApplyState
      }).then((res) => {
        if (res.data.code === '0' || res.data.code === 0) {
          this.setPrepaymentDetail(res.data.data)
        } else {
          this.setFailModal({
            show: true,
            content: res.data.result
          })
          this.$router.push({path: `/loanDetail/${this.$route.query.frontApplyId}`})
        }
      })
    }
  }
</script>
<style lang="scss">
  .prepayment_cont {
    .loan_detail_h1 {
      height: 35px;
      line-height: 20px;
      font-size: 20px;
      color: $personalCenterTitleBlack;
      margin-bottom: 0;
      text-indent: 5px;
      overflow: hidden;
    }

    .loan_detail_first {
      overflow: hidden;

      ul {
        width: 100%;
        height: 156px;
        margin-bottom: 20px;
        box-sizing: border-box;
        overflow: hidden;
        padding: 30px 15px 0 15px;
        border-radius: 7px;
        background: $white;

        li {
          width: 278px;
          height: 95px;
          float: left;
          border-left: 1px solid #eee;
          font-size: 25px;
          color: #59402E;
          font-weight: bold;

          &:first-child {
            border: none;

            em {
              color: $orange;
            }
            em:after {
              content: 'Outstanding amount';
            }
          }

          &:nth-child(2) {
            em {
              color: #333;
            }
            em:after {
              content: 'Loan amount';
            }

          }

          em {
            display: block;
            font-size: 17px;
            color: $personalCenterFormLabel;
            line-height: 32px;
            font-style: normal;

            &:after {
              display: block;
              margin-top: 2px;
              color: #3E454D;
              font-size: 12px;
              line-height: 12px;
              font-family: "MyriadPro-Regular";
            }

          }

          strong {
            display: block;
            line-height: 37px;
            font-family: "MyriadPro-Regular", "Microsoft YaHei";
            font-size: 30px;
            color: #374B5E;

            & i {
              font-size: 30px;
              font-style: normal;
              color: #59402e;
            }

            img {
              vertical-align: -3px;
            }

          }

          span {
            font-size: 12px;
            color: $lightSilver;
            display: block;
            margin-top: 5px;
          }

          .repay_btn {
            position: relative;
            display: inline-block;
            width: 110px;
            height: 35px;
            background: $orange;
            padding: 0;
            margin-top: 28px;
            border: 1px solid #FFA564;
            font-size: 14px;
            border-radius: 3px;

            span {
              margin: 0;
              display: inline-block;
              width: 100%;
              height: 35px;
              line-height: 35px;
              text-align: center;
              color: $white;
            }

            .el-icon-loading{
              position: absolute;
              left:15px;
              top:10px;
            }
          }
          .repay_btn.is-loading span{
            text-indent:20px;
          }
        }
      }
    }

    .repayment-tips {
      overflow: hidden;
      width: 100%;
      margin: 0px;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      text-indent: 30px;
      background: #E6E9EA url('../../../static/images/icons/failed_alert_icon.png') no-repeat 8px center;
      background-size: 15px;
      font-family: "FZLanTingHei_GBK";
    }

    .info-card {
      position: relative;
      margin-top: 20px;
      width: 100%;
      height: 68px;
      line-height: 68px;
      overflow: hidden;
      background: $white;

      .info-card-item {
        float: left;
        margin: auto;
        width: 25%;
        vertical-align: middle;

        .info-card-item-ch {
          margin-left: 30px;
          font-family: 'FZLanTingHei-DB-GBK';
          text-align: center;
          font-size: 14px;
          color: #3e454d;
        }

        .ml10{margin-left:10px;}

        .info-card-item-num {
          padding-left: 10px;
          max-width: 90px;
          font-family: 'MyriadPro-Bold';
          font-size: 14px;
          color: #35c4f9;
        }

        .max_110{
          max-width:130px;
          padding-left:0;
         .el-input__inner:hover,.el-input__inner{
           border:1px solid #e8e8e8;
         }
         .el-input-group__prepend{
           border:1px solid #e8e8e8;
           color:#35c4f9;
         }
        }

        .vertical-line {
          float: right;
          margin-top: 18px;
          width: 1px;
          height: 33px;
          border-right: 1px solid #e8e8e8;
        }
      }
    }
  }
        .repatmeny_money{
          padding:15px;
       }

       .repayTip{
         padding-left:10px;
         color:red;
       }

</style>



// WEBPACK FOOTER //
// Prepayment.vue?15c0301e